/* =============================================================
   KAYS COLLECTIVE — THEME JS  v1.0.0
   ============================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ── STICKY NAV SHADOW ─────────────────────────────────── */
  var nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── MOBILE MENU ────────────────────────────────────────── */
  var mobileToggle  = document.getElementById('mobileMenuToggle');
  var mobileMenu    = document.getElementById('MobileMenu');
  var mobileOverlay = document.getElementById('mobileOverlay');
  var mobileClose   = document.getElementById('mobileMenuClose');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    mobileMenu.removeAttribute('aria-hidden');
    if (mobileOverlay) mobileOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileOverlay) mobileOverlay.classList.remove('visible');
    document.body.style.overflow = '';
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose)  mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  /* ── SCROLL FADE-UP ─────────────────────────────────────── */
  var fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    var fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('visible');
          }, i * 75);
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    fadeEls.forEach(function (el) { fadeObserver.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── CART DRAWER ────────────────────────────────────────── */
  var cartDrawer  = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartToggle  = document.getElementById('cartToggle');

  window.openCart = function () {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
  };

  window.closeCart = function () {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('visible');
    document.body.style.overflow = '';
  };

  if (cartToggle) cartToggle.addEventListener('click', openCart);

  /* ── CART AJAX HELPERS ──────────────────────────────────── */
  function updateCartUI(cart) {
    var badge = document.getElementById('cartCountBadge');
    var count = document.getElementById('drawerCartCount');
    var total = document.getElementById('drawerCartTotal');
    var footer = document.getElementById('drawerCartFooter');

    if (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    }
    if (count) count.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (footer) footer.hidden = cart.item_count === 0;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  function refreshDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartUI(cart); })
      .catch(function (e) { console.warn('Cart refresh error', e); });
  }

  /* ── QUICK ADD TO CART ──────────────────────────────────── */
  window.quickAddToCart = function (variantId, title, price) {
    if (!variantId || variantId === 'undefined') {
      showToast('⚠️ Product unavailable');
      return;
    }
    var btn = event && event.target;
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function () {
        showToast('🌸 "' + title + '" added to cart!');
        refreshDrawer();
        refreshDrawerItems();
        setTimeout(openCart, 350);
      })
      .catch(function (e) {
        console.warn('Add to cart error', e);
        showToast('⚠️ Could not add to cart. Please try again.');
      })
      .finally(function () {
        if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      });
  };

  function refreshDrawerItems() {
    var itemsEl = document.getElementById('drawerCartItems');
    if (!itemsEl) return;
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.getElementById('drawerCartItems');
        var newFooter = doc.getElementById('drawerCartFooter');
        var footerEl = document.getElementById('drawerCartFooter');
        if (newItems) itemsEl.innerHTML = newItems.innerHTML;
        if (newFooter && footerEl) {
          footerEl.innerHTML = newFooter.innerHTML;
          footerEl.hidden = newFooter.hidden;
        }
      })
      .catch(function () { /* silently fail, cart is still updated */ });
  }

  /* ── DRAWER QTY UPDATE ──────────────────────────────────── */
  window.drawerQtyUpdate = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartUI(cart);
        refreshDrawerItems();
      })
      .catch(function (e) { console.warn('Cart change error', e); });
  };

  /* ── PRODUCT FORM AJAX ──────────────────────────────────── */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = document.getElementById('ProductVariantId').value;
      var qty = parseInt(document.getElementById('ProductQty') ? document.getElementById('ProductQty').value : 1) || 1;
      var addBtn = document.getElementById('AddToCartBtn');
      var addText = document.getElementById('AddToCartText');

      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          showToast('🌸 Added to cart!');
          refreshDrawer();
          refreshDrawerItems();
          setTimeout(openCart, 350);
        })
        .catch(function () { showToast('⚠️ Could not add to cart.'); })
        .finally(function () {
          if (addBtn) addBtn.disabled = false;
          if (addText) addText.textContent = 'Add to Cart';
        });
    });
  }

  /* ── QUICK VIEW MODAL ───────────────────────────────────── */
  var modalOverlay = document.getElementById('modalOverlay');
  var currentModalVariantId = null;

  window.openQuickView = function (handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants[0];
        currentModalVariantId = variant.id;

        var titleEl    = document.getElementById('modalTitle');
        var priceEl    = document.getElementById('modalPrice');
        var addPriceEl = document.getElementById('modalAddPrice');
        var catEl      = document.getElementById('modalCategory');
        var imgEl      = document.getElementById('modalImage');
        var descEl     = document.getElementById('modalDesc');
        var viewLink   = document.getElementById('modalViewLink');

        var priceFormatted = formatMoney(variant.price);
        if (titleEl)    titleEl.textContent    = product.title;
        if (priceEl)    priceEl.textContent    = priceFormatted;
        if (addPriceEl) addPriceEl.textContent = priceFormatted;
        if (catEl)      catEl.textContent      = product.product_type || 'Kays Collective';
        if (imgEl) {
          if (product.images && product.images[0]) {
            imgEl.innerHTML = '<img src="' + product.images[0] + '" alt="' + product.title.replace(/"/g, '') + '" style="width:100%;height:100%;object-fit:cover;border-radius:12px;">';
          } else {
            imgEl.textContent = '🌸';
          }
        }
        if (descEl) {
          var tmp = document.createElement('div');
          tmp.innerHTML = product.body_html || '';
          descEl.textContent = (tmp.textContent || '').substring(0, 130).trim() + (tmp.textContent.length > 130 ? '…' : '');
        }
        if (viewLink) viewLink.href = '/products/' + handle;

        if (modalOverlay) modalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      })
      .catch(function (e) {
        console.warn('Quick view error', e);
        showToast('⚠️ Could not load product. Click to view.');
      });
  };

  window.handleModalOverlayClick = function (e) {
    if (e.target === modalOverlay) closeModal();
  };

  window.closeModal = function () {
    if (modalOverlay) modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
    currentModalVariantId = null;
  };

  var modalAddBtn = document.getElementById('modalAddBtn');
  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', function () {
      if (!currentModalVariantId) return;
      var title = document.getElementById('modalTitle') ? document.getElementById('modalTitle').textContent : 'Product';
      var price = document.getElementById('modalPrice') ? document.getElementById('modalPrice').textContent : '';
      quickAddToCart(currentModalVariantId, title, price);
      closeModal();
    });
  }

  var modalWishlistBtn = document.getElementById('modalWishlistBtn');
  if (modalWishlistBtn) {
    modalWishlistBtn.addEventListener('click', function () {
      showToast('❤️ Saved to wishlist!');
    });
  }

  document.querySelectorAll('.format-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var siblings = this.closest('.modal__formats') ? this.closest('.modal__formats').querySelectorAll('.format-btn') : [];
      siblings.forEach(function (b) { b.classList.remove('format-btn--active'); });
      this.classList.add('format-btn--active');
    });
  });

  /* ── SEARCH MODAL ───────────────────────────────────────── */
  var searchModal   = document.getElementById('SearchModal');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchToggle  = document.getElementById('searchToggle');
  var searchInput   = document.getElementById('SearchInput');

  function openSearch() {
    if (!searchModal) return;
    searchModal.removeAttribute('hidden');
    searchModal.classList.add('open');
    if (searchOverlay) searchOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 100);
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
  }

  window.closeSearch = function () {
    if (!searchModal) return;
    searchModal.classList.remove('open');
    if (searchOverlay) searchOverlay.classList.remove('visible');
    document.body.style.overflow = '';
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    setTimeout(function () { searchModal.setAttribute('hidden', ''); }, 320);
  };

  window.clearSearch = function () {
    if (searchInput) { searchInput.value = ''; searchInput.focus(); }
    var results = document.getElementById('searchResults');
    if (results) results.innerHTML = '';
    var clearBtn = document.getElementById('searchClear');
    if (clearBtn) clearBtn.hidden = true;
  };

  if (searchToggle) searchToggle.addEventListener('click', openSearch);

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var clearBtn = document.getElementById('searchClear');
      if (clearBtn) clearBtn.hidden = !this.value;
      if (this.value.length > 2) runPredictiveSearch(this.value);
    });
  }

  function runPredictiveSearch(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var results = document.getElementById('searchResults');
        if (!results) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) { results.innerHTML = ''; return; }
        results.innerHTML = products.map(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="" style="width:48px;height:48px;object-fit:cover;border-radius:6px;">' : '<div style="width:48px;height:48px;background:#f0ece8;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:20px;">🌸</div>';
          return '<a href="' + p.url + '" style="display:flex;align-items:center;gap:12px;padding:10px;border-radius:8px;transition:background .2s;text-decoration:none;color:#3a3535;" onmouseover="this.style.background=\'#f8f5f2\'" onmouseout="this.style.background=\'\'">' +
            img +
            '<div><div style="font-family:\'Playfair Display\',serif;font-style:italic;font-size:15px;">' + p.title + '</div>' +
            '<div style="font-family:\'Lato\',sans-serif;font-size:12px;color:#9a9a9a;">' + formatMoney(p.price) + '</div></div>' +
            '</a>';
        }).join('');
      })
      .catch(function () {});
  }

  /* ── WISHLIST (localStorage) ────────────────────────────── */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('kc_wishlist') || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('kc_wishlist', JSON.stringify(list)); } catch (e) {}
  }

  window.toggleWishlist = function (btn, productId) {
    var id = String(productId);
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
      btn.classList.add('active');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#c9a090" stroke="#c9a090" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      showToast('❤️ Saved to wishlist!');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('active');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      showToast('Removed from wishlist');
    }
    saveWishlist(list);
  };

  // Restore active wishlist state
  var wishlist = getWishlist();
  document.querySelectorAll('.product-card__wishlist[onclick]').forEach(function (btn) {
    var match = btn.getAttribute('onclick').match(/'(\d+)'/);
    if (match && wishlist.indexOf(match[1]) !== -1) {
      btn.classList.add('active');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#c9a090" stroke="#c9a090" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    }
  });

  /* ── TOAST ──────────────────────────────────────────────── */
  var toastTimer;
  window.showToast = function (msg) {
    var toast = document.getElementById('toast');
    var msgEl = document.getElementById('toastMessage');
    if (!toast) return;
    if (msgEl) msgEl.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3200);
  };

  /* ── TESTIMONIALS SLIDER ────────────────────────────────── */
  var slideCurrent = 0;
  var slideTrack = document.getElementById('testimonialsTrack');

  window.goToSlide = function (index) {
    if (!slideTrack) return;
    slideCurrent = index;
    var card = slideTrack.querySelector('.testimonial-card');
    if (!card) return;
    var cardW = card.offsetWidth + 22;
    slideTrack.style.transform = 'translateX(-' + (index * cardW) + 'px)';
    document.querySelectorAll('.testimonials-dot').forEach(function (dot, i) {
      dot.classList.toggle('active', i === index);
    });
  };

  if (slideTrack) {
    var dotCount = document.querySelectorAll('.testimonials-dot').length;
    if (dotCount > 1) {
      setInterval(function () {
        slideCurrent = (slideCurrent + 1) % dotCount;
        goToSlide(slideCurrent);
      }, 5500);
    }
  }

  /* ── PETAL CURSOR TRAIL ─────────────────────────────────── */
  var petals = ['🌸', '🌺', '✿', '🌷', '✦', '❀'];
  var lastPetal = 0;
  document.addEventListener('mousemove', function (e) {
    var now = Date.now();
    if (now - lastPetal < 130 || Math.random() > 0.35) return;
    lastPetal = now;
    var el = document.createElement('div');
    el.className = 'cursor-petal';
    el.setAttribute('aria-hidden', 'true');
    el.textContent = petals[Math.floor(Math.random() * petals.length)];
    el.style.cssText = 'left:' + e.clientX + 'px;top:' + e.clientY + 'px;';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 950);
  }, { passive: true });

  /* ── KEYBOARD ESC ───────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeModal();
    closeCart();
    closeSearch();
    closeMobileMenu();
  });

  /* ── SMOOTH ANCHOR LINKS ────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── COLLECTION SORT RESTORE ────────────────────────────── */
  var sortSelect = document.getElementById('CollectionSort');
  if (sortSelect) {
    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get('sort_by');
    if (sortBy) sortSelect.value = sortBy;
  }

  /* ── DONE ───────────────────────────────────────────────── */
  console.log('✦ Kays Collective theme v1.0.0 loaded ✦');
});
